import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { Patient } from "../patients/patient";
import { PatientsService } from "../patients.service";
import { ExamsService } from "../exams.service";
import { LoginService } from "../login.service";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommerrorService } from "../commerror.service";
import { PregnancyService } from "../pregnancy.service";
import { GastroFormsService } from "../gastro-forms.service";
import { DiagnosisService } from "../diagnosis.service";
import { CalendarService } from "../calendar.service";
import { HttpClient } from "@angular/common/http";
import { SignatureService } from "../signature.service";
import { Exam } from "../interfaces/exams.service/types";
import { DatePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

export interface PrintHistoryTable {
  date: string;
  position: number;
  time: string;
  comments: string;
}

@Component({
    selector: "app-patexams",
    templateUrl: "./patexams.component.html",
    styleUrls: ["./patexams.component.scss"],
    standalone: false
})
export class PatexamsComponent implements OnInit, OnDestroy {
  @ViewChild("inputTitle")
  set inputTitle(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }
  inform = false;
  showComment = false;
  selectedForm;
  calendarForm: boolean = false;
  pat: Patient;
  showPat: boolean = false;
  pregnancies: any = null;
  etype: string = "OB STD";
  typeForm = false;
  examname: string;
  concentForm;
  otherExams: any;
  formsExams: any[] = [];
  calendarForms: any[] = [];
  notFormExams: any[] = [];
  AttachedDocuments: any[] = [];
  ecgExams: any[] = [];
  PneumologyExams: any = [];
  gastroForms: any[] = [];
  gastroVisits: any[] = [];
  gastroExams: any[] = [];
  letters: any;
  showLogin = false;
  AWLAlreadyExists = false;
  private destroy$ = new Subject();
  public examsLoaded$ = new Subject();
  toDelete;
  deleteDenied = "";
  readydelete = false;
  goEx;
  newExam = true;
  closePreg: number = null;
  pregExams;
  defaults;
  startClinic: number;
  openAWL = false;
  subscription = new Subscription();
  FORMS = ["Consultation Letter", "Inform Consent"];
  ECG = ["Resting ECG", "Ergometry", "Stress", "Holter ECG"];
  CARDIO = ["TTE Adults", "TTE Pediatric", "Duplex Carotid", "Stress-Echo", "Holter ECG", "Stress","Pulmonary functional assessment","Methacholine test"];
  GASTRO = ["Colonoscopy", "Gastroscopy", "Sigmoidoscopy"];
  INVASIVE = ["Amniocentesis", "CVS"];
  Pneumology = ["Pulmonary functional assessment","Methacholine test"];
  openDocumentsAdd = false;
  documentDelete = false;
  showPneumology = false;

  GastroForms = ["Admission Form", "Time Out Form"];
  gastroExamsChanged = new Subject();
  fanciness = "simple";

  similarPatientIdMsg: boolean = false;
  similarPatientIdArray;

  private examUnSignedSub: Subscription;

  // Print Hisory:
  showPrintHistoryPopup = false;
  loadingPrint = false;
  printHistoryData: any;
  displayedColumns: string[] = ["position", "date", "time", "comments"];
  clickedRows = new Set<PrintHistoryTable>();
  examId: number;

  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  questionnaireList: any[] = [];

  constructor(
    public ce: CommerrorService,
    public gfs: GastroFormsService,
    public patService: PatientsService,
    public ps: PregnancyService,
    public examService: ExamsService,
    public login: LoginService,
    public ds: DiagnosisService,
    public cf: CalendarService,
    public signatureService: SignatureService,
    public translate: TranslateService,
    private datePipe: DatePipe,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.login.loginMissing();
    try {
      this.pat = this.patService.getPat();
      //this.pat.asignVals(history.state.data);
    } catch {}
    // AR-24 change 2: load this patient's questionnaire sends for the history list.
    this.loadQuestionnaireList();
    if (this.login.isCardio) {
      this.etype = "Echo";
    }
    if (this.login.category.name == "forms") {
      this.etype = "Forms";
    }
    if (this.login.hasPremission("Pneumology") || this.login.hasPremission("Methacholine")) {
      this.etype = "Pneumology";
      this.showPneumology = true;
    }
    if (this.pat && this.pat.ID != "default") {
      this.resetPregs();
    } else {
      //defaults
      this.examService.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data["length"]; i++) this.defaults[data[i]["ExamType"]] = data[i];
        },
        (error) => {
          console.error(error);
        }
      );
    }
    this.subscription = this.patService.lettersChange.subscribe((response) => {
      this.letters = response;
    });
    this.subscription = this.cf.caldeleted$.subscribe((data) => {
      this.resetPregs();
    });
    if (this.pat?.ID === "default") this.examService.getCustomTitles();
  }

  resetPregs() {
    this.examService
      .getExams(this.pat.PID.toString())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.checkSimilarPatientId();
          this.AttachedDocuments = data["Documents"];
          this.notFormExams = [];
          this.ecgExams = [];
          this.PneumologyExams = [];
          this.formsExams = [];
          this.pregnancies = data["pregnancies"];
          this.examService.pregnancies = data["pregnancies"];
          for (let item of this.pregnancies) {
            this.examService
              .getAllCalForms(item.AutoIndex)
              .pipe(takeUntil(this.destroy$))
              .subscribe((data) => {
                if (data[0].calendar.length > 0) item.calendarForms.push(data[0].calendar[0]);
                if (data[0].concent.length > 0) item.forms = data[0].concent;
                // for(let concentForm of data[0].concent)
                // item.forms.push(concentForm)
              });
            // this.examServe.getConcentForms(item.AutoIndex).subscribe((data) => {
            //   if(data[0])
            //     item.forms.push(data[0])
            // })
          }

          if (this.pregnancies && this.pregnancies.length > 0 && this.pregnancies[0].LMP)
            this.pat.LMP = this.pregnancies[0].LMP;
          // this.letters = this.patService.getConsultationLetter(this.pat);
          this.otherExams = data["other"];
          if (this.otherExams.length > 0) {
            this.otherExams.forEach((exam) => {
              if (this.FORMS.includes(exam.ExamType)) {
                this.formsExams.push(exam);
              } else {
                if (this.ECG.includes(exam.ExamType)) this.ecgExams.push(exam);
                else if (this.Pneumology.includes(exam.ExamType)) {
                  this.PneumologyExams.push(exam);
                } else this.notFormExams.push(exam);
              }
            });
          }
          if (this.login.isGastro) {
            this.examsLoaded$.next(undefined);
            this.ds.BuildList;
          }
          if (this.pat.AWLID) {
            if (!this.login.isGastro) {
              for (let i = 0; i < this.pregnancies.length; i++) {
                for (let e of this.pregnancies[i]["exams"]) {
                  if (e.AWLID == this.pat.AWLID) {
                    this.AWLAlreadyExists = true;
                    return;
                  }
                }
              }
            }
            for (let e of this.otherExams) {
              if (e.AWLID == this.pat.AWLID) {
                this.AWLAlreadyExists = true;
                return;
              }
            }
          } else {
            if (this.login.isCardio) {
              this.patService.getPatAWL();
            }
          }
        },
        (error) => {
          //add this later
          console.error(error);
        }
      );
    this.subscription = this.examsLoaded$.subscribe(() => {
      var v = this.gfs.getVisits(this.pat.PID);
      v.subscribe((data: any) => {
        this.gastroVisits = data;
        this.gastroVisits.forEach((visit, i) => {
          this.gastroVisits[i]["exams"] = this.gastroExams.filter((exam) => {
            return exam.CreationTime.split("T")[0] == visit.ExamDate.split("T")[0];
          });
          var f = this.gfs.getFormByVisit(visit.AutoIndex);
          f.subscribe((data) => {
            this.gastroVisits[i]["forms"] = data;
          });
        });
        this.gfs.loadForm(false, true, this.gastroVisits[0]["AWLID"]);
      });
    });
    this.login.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      /*if(this.login.ClinicID && this.login.ClinicID != this.startClinic){
        //trying to switch clinics on opening exams
        this.showLogin=false;
        this.cErr.Error = "Clinic Not Autorized on this patient";
        this.cErr.ErrorType = "Clinic Switched on Login";
        return;
      }*/
      if (this.goEx) {
        this.examService.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      } else {
        if (this.etype == "GastroForms" || this.examname == "Inform Consent" || this.concentForm) {
          this.showLogin = false;

          if (this.etype == "GastroForms") {
            this.typeForm = true;
            this.inform = false;
            var awl = this.pat.AWLID
              ? this.pat.AWLID.toString()
              : this.gastroVisits[0].AutoIndex.toString();
            this.examsLoaded$.next(undefined);
          }
          if (this.examname == "Inform Consent" || this.concentForm) this.inform = true;
        } else {
          if (
            this.pregnancies.length > 0 &&
            this.pregnancies[0].forms.filter((i) => i.ExamType == this.examname && !i.ExamID).length ==
              0 &&
            !this.login.ishospital &&
            this.login.hasPremission('Consent')
          ) {
            this.inform = true;
            this.showLogin = false;
            this.examService.openNewExam = true;
          } else {
            if (this.pregnancies.length > 0)
              this.examService.concentForm = this.pregnancies[0].forms.filter(
                (i) => i.ExamType == this.examname && !i.ExamID
              )[0];
            this.examService.startExam(
              this.examname,
              this.pat.PID,
              this.pat.ID,
              this.pat.AWLID,
              this.pat.ExamLMP
            );
          }
        }
      }
    });
  }

  viewonly() {
    this.examService.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }
  startForm(form = null) {
    if (this.examname == "Inform Consent" || form) {
      this.examService.examID = null;
      this.concentForm = form;
      this.showLogin = true;
      this.examService.openNewExam = false;
    } else {
      this.concentForm = null;
      this.inform = false;
      var today = new Date().toISOString().split("T")[0];
      var checkAwl = true;
      if (this.gastroVisits.length > 0) {
        checkAwl =
          new Date(this.gastroVisits[0].ExamDate.split("T")[0]).toISOString().split("T")[0] !== today;
      }
      if (this.GastroForms.includes(this.examname) && checkAwl) {
        return this.ce.errorGastro(
          "Today List Missing",
          "A TodayList has to be generated before a new exam can be opened!"
        );
      }
      this.showLogin = true;
      return;
    }
  }
  goForm(form) {
    this.typeForm = true;
    var isTimeOut = form["FormName"] == "Time Out Form";
    this.gfs.loadForm(isTimeOut, form);
  }

  startExam() {
    if (this.examname === 'Send Questionnaire') { this.openSendQuestionnaireForPatient(); return; }
    if (this.examService.awaitPrintHistory && this.pat.ID !== "default") {
      return;
    }
    var today = new Date().toISOString().split("T")[0];
    this.examService.examID = null;
    var checkAwl = true;
    if (this.gastroVisits.length > 0) {
      checkAwl =
        new Date(this.gastroVisits[0].ExamDate.split("T")[0]).toISOString().split("T")[0] !== today;
    }
    if (this.login.isCardio) {
      checkAwl = this.patService.getPat().AWLID == null;
    }
    if (this.CARDIO.includes(this.examname) && checkAwl && this.pat.ID != "default") {
      return this.ce.errorGastro(
        "Today List Missing",
        "A TodayList has to be generated before a new exam can be opened!"
      );
    }

    if (!this.etype || !this.examname) return;
    if (this.pat.ID != "default") {
      this.concentForm = null;
      this.newExam = true;
      this.showLogin = true;
      return;
      // this.examServe.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP);
    } else {
      //default
      if (this.defaults[this.examname]) {
        this.examService.goExam(null, this.defaults[this.examname], this.examname);
      } else this.examService.startExam(this.examname, 0, "default");
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.examUnSignedSub) {
      this.examUnSignedSub.unsubscribe();
    }
  }

  canOpen(): boolean {
    return (
      this.login.canStartExam(this.pat.AWLID != null) &&
      (!this.AWLAlreadyExists || this.login.AWLUnlimited) &&
      (!this.login.separatedClinic ||
        this.login.isAdmin ||
        !this.patService.getPat().UID ||
        this.patService.getPat().UID == this.login.UID ||
        this.patService.getPat()["AWLUID"] == this.login.UID)
    );
  }

  private canOpenExam = (userType: string): boolean => {
    return userType === "doctor" || userType === "visitingdoc" || userType === "tech";
  };

  private canReOpenExam = (userType: string): boolean => {
    return userType === "doctor" || userType === "visitingdoc";
  };

  goExam(pregid: number, exam, examtype: string, examtime: string) {
    const isExamSigned = this.signatureService.isExamSigned(exam);
    const userType = this.login.userType;
    this.examService.examObject = exam;

    // For login for Edit, reassign new un-singed exam to the goEx:
    this.examUnSignedSub = this.signatureService.examUnSigned$.subscribe((data: Exam) => {
      this.goEx = { preg: pregid, exam: data, etype: examtype };
    });

    if (
      (exam.Locked && exam.LockedBy.toLowerCase() != this.login.loginname.toLowerCase()) ||
      !this.canView(exam)
    )
      return;
    let etime = new Date(examtime);
    var closed;
    if (exam.ClosedDate) closed = new Date(exam.ClosedDate);
    let now = new Date();
    if (!isExamSigned && this.canOpenExam(userType)) {
      this.newExam = false;
      this.showLogin = true;
      this.goEx = { preg: pregid, exam: exam, etype: examtype };
      if (this.login.ClinicID) {
        this.startClinic = this.login.ClinicID;
      }
    } else if (isExamSigned && !this.canReOpenExam(userType)) {
      this.examService.goExam(pregid, exam, examtype, true);
    } else {
      if (this.canOpenExam(userType)) {
        this.newExam = false;
        this.showLogin = true;
        this.examService.examID = exam.AutoIndex;
        this.goEx = { preg: pregid, exam: exam, etype: examtype };
      } else {
        this.examService.goExam(pregid, exam, examtype, true);
      }
      // this.examServe.goExam(pregid, exam, examtype);
    }
  }

  canView(exam) {
    return (
      !this.login.separatedClinic ||
      this.login.isAdmin ||
      this.login.userType == "secretary" ||
      exam.UID == this.login.doctor
    );
  }

  askDelete(exam, document = false) {
    if (document) {
      this.documentDelete = true;
      this.toDelete = exam; /**document */
    } else if (this.defaults || this.examService.canDeleteExam(exam)) {
      this.toDelete = exam;
    } else {
      this.deleteDenied = this.examService.deleteDeniedReason(exam);
    }
    return false;
  }

  deleteExam() {
    const deleted = this.toDelete;
    this.examService.deleteExam(deleted.AutoIndex, deleted.AWLID).subscribe(
      () => {
        if (this.defaults) {
          this.examService.getDefaults().subscribe(
            (data) => {
              this.defaults = [];
              for (let i = 0; i < data["length"]; i++) this.defaults[data[i]["ExamType"]] = data[i];
            },
            (error) => {
              console.error(error);
            }
          );
          return;
        }
        this.pat.AWLID = deleted.AWLID;
        for (let i = 0; i < this.pregnancies.length; i++) {
          this.removeExamFrom(this.pregnancies[i]["exams"], deleted.AutoIndex);
        }
        for (let list of [
          this.otherExams,
          this.notFormExams,
          this.ecgExams,
          this.PneumologyExams,
          this.formsExams,
        ]) {
          this.removeExamFrom(list, deleted.AutoIndex);
        }
      },
      (error) => {
        console.error(error);
      }
    );
    this.toDelete = null;
    this.readydelete = false;
  }

  private removeExamFrom(list, autoIndex) {
    if (!list) return;
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].AutoIndex == autoIndex) list.splice(i, 1);
    }
  }

  showClose(pregid: number) {}
  closCalForm(event) {
    if (event == "2" || this.examService.openNewExam) {
      this.examService.startExam(
        this.examname,
        this.pat.PID,
        this.pat.ID,
        this.pat.AWLID,
        this.pat.ExamLMP,
        this.examService.concentForm
      );
    }
    this.examService.openNewExam = false;
    this.calendarForm = false;
    this.inform = false;
    if (this.pat.ID != "default") {
      this.resetPregs();
    } else {
      //defaults
      this.examService.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data["length"]; i++) this.defaults[data[i]["ExamType"]] = data[i];
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  deleteDefault(ex: string) {
    if (this.defaults[ex]) {
      this.askDelete(this.defaults[ex]);
    }
  }

  getDiagnosis(exam, show = false) {
    var strDiagnosis = "No relevant data";
    if (exam && exam.DiagnosisCodes) {
      var temp = this.ds.BuildList(exam.DiagnosisCodes);
      if (temp.length > 0) {
        strDiagnosis = "";
        for (let i = 0; i < temp.length; i++) {
          strDiagnosis += temp[i][1].split(">")[temp[i][1].split(">").length - 1];
          if (temp.length > 1 && i < temp.length - 1) strDiagnosis += ",";
        }
      }
    } else if (exam && exam.Anomalies && exam.Anomalies != "") strDiagnosis = exam.Anomalies;
    if (show && exam["Anomalies"] && exam.Anomalies.length > 15)
      // return 'Read More'
      return exam.Anomalies.split(" ")[0] + "...";
    else return strDiagnosis;
  }
  loadCalendarForm(form) {
    this.calendarForm = true;
    this.selectedForm = form;
  }

  getConcent(exam) {
    var temp = this.examService.pregnancies.filter((i) => i.AutoIndex == exam.PregIndex);
    if (temp.length > 0) {
      temp = temp[0].forms.filter((i) => i.ExamID == exam.AutoIndex);
    }
    if (temp.length > 0) return temp[0];
    else return false;
  }

  pregClosed() {
    for (let p of this.pregnancies) {
      if (p.AutoIndex == this.closePreg) p.ClosedDate = new Date();
    }
    this.closePreg = null;
  }

  openDocument(docId) {
    window.open(`api/patient/getDocument/${docId}`);
  }

  deleteDocument() {
    console.log(this.toDelete, "to delete");
    if (!this.toDelete || !this.toDelete.AutoIndex) return;
    this.http.delete(`api/patient/document/${this.toDelete.AutoIndex}`).subscribe(() => {
      this.resetPregs();
      this.toDelete = null;
      this.documentDelete = false;
    });
  }

  checkSimilarPatientId() {
    if (this.examService.checkSimilarId) {
      this.examService.hasSimilarPatientId(this.pat.ID).subscribe((data) => {
        if (Array.isArray(data) && data["similarMatches"].length > 0) {
          this.similarPatientIdMsg = true;
          this.similarPatientIdArray = data["similarMatches"];
          this.examService.checkSimilarId = false;
        }
      });
    }
  }

  redirectAdministration(type) {
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data + "/" + this.patService.currentPatient.PID;
    });
  }

  // This function retrieves a list of print histories for a given exam.
  getPrintHistoryList(exam) {
    if (this.examService.awaitPrintHistory) {
      return;
    }
    this.loadingPrint = true;
    if (!exam) {
      return;
    }
    this.examId = exam.AutoIndex;
    try {
      this.http.get(`api/print-history/list/${this.examId.toString()}`).subscribe((data) => {
        const sortedData = Object.values(data);
        sortedData.sort(
          (a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime()
        );

        // Convert creationDate to UTC for each element
        sortedData.forEach((element) => {
          element.creationTime = this.formatDateToUTC(element.creationDate);
          element.creationDate = element.creationDate;
        });

        this.printHistoryData = sortedData;
        this.loadingPrint = false;
      });
    } catch (error) {
      console.error(error);
    }
  }

  // Prints a PDF file from a selected row.
  printSelectPDF(selectRow) {
    this.loadingPrint = true;
    this.http
      .get(`/api/print-history/print/${this.examId.toString()}/${selectRow.fileName}`, {
        responseType: "blob",
      })
      .subscribe((data) => {
        const file = new Blob([data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.loadingPrint = false;
      });
  }

  // This function toggles the print history popup.
  togglePrintHistoryPopup() {
    if (this.examService.awaitPrintHistory) {
      return;
    }
    this.showPrintHistoryPopup = !this.showPrintHistoryPopup;
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24 change 2: open the answered-questionnaire PDF (same-origin proxy).
  openQuestionnairePdf(q: any) {
    if (q && q.answeredDate && q.code) {
      window.open("api/questionnaires/pdf/" + q.code);
    }
  }

  // AR-24: triggered from Create-New > Letters and Certificates > Send
  // Questionnaire. No ExamType is passed, so the popup preselects nothing
  // and the user picks which questionnaire to send.
  openSendQuestionnaireForPatient() {
    if (this.pat) {
      this.openSendQuestionnaire({ Mobile: this.pat.Mobile, ID: this.pat.ID, PID: this.pat.PID });
    } else {
      this.openSendQuestionnaire({});
    }
  }

  // AR-24 change 2: load this patient's questionnaire sends for the history list.
  loadQuestionnaireList() {
    if (this.pat && this.pat.PID != null) {
      this.examService.getPatientQuestionnaires(this.pat.PID).subscribe(
        (data: any) => {
          this.questionnaireList = (data && data.items) || [];
        },
        (err) => console.log(err)
      );
    }
  }

  onSendQuestionnaireClosed() {
    this.showSendQuestionnaire = false;
    if (this.pat && this.pat.PID != null) { this.resetPregs(); this.loadQuestionnaireList(); }
  }

  private formatDateToUTC(dateString: string): string {
    const date = new Date(dateString);
    // Convert local date to UTC
    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
    // Format date to string using the desired format and timezone ('Asia/Jerusalem' in this case)
    return this.datePipe.transform(utcDate, "HH:mm", "Asia/Jerusalem");
  }
}
